import { Component, Input, OnInit } from '@angular/core';
import { PageRequest, SpringPage } from '@shared/page';
import { AdminContractService, CollectionApi } from '@shared/services/admin-contract.service';

@Component({ template: '' })
export abstract class ContractCollectionComponent<T, U extends T = T> implements OnInit {
  @Input({ required: true }) contractNumber: string;

  data: SpringPage<T> | undefined;
  page: PageRequest = { number: 0, size: 10 };
  addItem: U;

  rowType = { row: {} as T };

  constructor(public admin: AdminContractService) {}

  ngOnInit() {
    this.refreshData();
  }

  changePage(page: number) {
    this.page = { ...this.page, number: page };
    this.refreshData();
  }

  async refreshData() {
    this.data = await this.getData(this.page);
  }

  protected abstract getCollectionApi(): CollectionApi<U>;

  protected abstract getItemId(item: T): any;

  getData(page: PageRequest): Promise<SpringPage<T>> {
    return this.getCollectionApi().getPage(page);
  }

  add(item: T) {
    this.getCollectionApi()
      .add(this.getItemId(item))
      .subscribe(() => this.refreshData());
  }

  remove(item: T) {
    this.getCollectionApi()
      .remove(this.getItemId(item))
      .subscribe(() => this.refreshData());
  }
}
